module.exports = __webpack_public_path__ + "static/media/a.ac79ac14.jpg";